<template>
  <div class="events-filters">
      <b-row>
          <b-col>name</b-col>
          <b-col>desde</b-col>
          <b-col>hasta</b-col>
      </b-row>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
